import React from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../components/Navigation';
import Footer from '../components/Footer';
import articles from '../content/manifest.json';

const Insights = () => {
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return new Intl.DateTimeFormat('en-US', {
      year: 'numeric',
      month: 'long',
      day: 'numeric',
      timeZone: 'UTC',
    }).format(date);
  };

  return (
    <div>
      <Navigation />

      {/* Hero Section */}
      <section className="hero-section bg-gradient-to-br from-gray-900 via-onyx-900 to-gray-900">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center">
            <h1 className="text-4xl sm:text-5xl md:text-6xl text-white mb-9">
              Insights
            </h1>
            <p className="text-xl text-white max-w-3xl mx-auto leading-relaxed">
              Expert analysis on health policy, conference recaps, and strategic perspectives from Onyx Rose Advisors.
            </p>
          </div>
        </div>
      </section>

      {/* Articles Grid */}
      <section className="py-24 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {articles.map((article) => (
              <Link
                key={article.slug}
                to={`/insights/${article.slug}`}
                className="bg-white rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 overflow-hidden group"
              >
                {article.image && (
                  <div className="aspect-video overflow-hidden">
                    <img
                      src={article.image}
                      alt={article.title}
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                )}
                <div className="p-8">
                  <div className="text-sm text-accent font-semibold mb-3">
                    {formatDate(article.date)} &middot; {article.readingTime} min read
                  </div>
                  <h2 className="text-2xl font-bold text-gray-900 mb-4 group-hover:text-accent transition-colors duration-200">
                    {article.title}
                  </h2>
                  <p className="text-gray-700 leading-relaxed mb-6">
                    {article.description}
                  </p>
                  <span className="inline-block text-accent font-semibold">
                    Read more &rarr;
                  </span>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Insights;
